import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { viewAmenitiesList } from "../../Redux/Actions/amenitiesResaleActions";
import { columnsResaleAmenities } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListAmenities = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchAmenitiesDetails = useCallback(
    async (page, pageSize, showLoader = true) => {
      const payload = {
        page,
        limit: pageSize,
        is_deleted: false,
        filter: debouncedSearch,
        ...(dateRange.start && {
          start_date: dateRange.start.format("YYYY-MM-DD"),
        }),
        ...(dateRange.end && {
          end_date: dateRange.end.format("YYYY-MM-DD"),
        }),
      };

      try {
        await dispatch(viewAmenitiesList(payload, showLoader));

        if (!showLoader) {
          toast.success("Amenities list refreshed");
        }
      } catch {
        if (!showLoader) {
          toast.error("Failed to refresh amenities list");
        }
      }
    },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchAmenitiesDetails(pagination.current, pagination.pageSize);
  }, [fetchAmenitiesDetails, pagination.current, pagination.pageSize]);

  const { amenitiesResale, loading } = useSelector(
    (state) => state.amenitiesResale
  );

  useEffect(() => {
    if (amenitiesResale?.total !== undefined) {
      setPagination((prev) => ({
        ...prev,
        total: amenitiesResale.total,
      }));
    }
  }, [amenitiesResale]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPagination((prev) => ({ ...prev, current: 1 }));
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }

    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <MainLayout>
      <div className="dashboard-container">
        <div className="table_component_all">
          <ListTopSearch
            buttonhead={canAdd ? "Add Amenities Resale" : null}
            navigateTo={canAdd ? "/amenities_resale/add" : null}
            h3heading="Amenities Resale List"
            setState={setSearchQuery}
            onCalendarClick={() => setIsDatePopupVisible(true)}
          />

          <div style={{ overflowX: "auto", padding: "0px 60px" }}>
            <Table
              rowKey={(record) => record?._id || record?.id}
              dataSource={Array.isArray(amenitiesResale?.data) ? amenitiesResale.data : []}
              pagination={pagination}
              scroll={{ x: 1700, y: 500 }}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsResaleAmenities(canEdit)}
              rowClassName={() => "text-center"}
            />
          </div>
        </div>

        <DateRangePopup
          visible={isDatePopupVisible}
          initialStart={dateRange.start}
          initialEnd={dateRange.end}
          onCancel={() => setIsDatePopupVisible(false)}
          onOk={handleDateRangeApply}
        />
      </div>
    </MainLayout>
  );
};

export default ListAmenities;